import { useIssueTypesActions } from '@atlassian/jira-admin-pages-issue-types-resources/src/controllers/issue-types/main.tsx';
import { issueTypesResource } from '@atlassian/jira-admin-pages-issue-types-resources/src/controllers/issue-types/utils.tsx';
import { useResource } from '@atlassian/react-resource-router';

export const ResourceHandler = () => {
	const [, { storeResourceResult }] = useIssueTypesActions();
	const { data, error, loading } = useResource(issueTypesResource);

	// @ts-expect-error - TS2345 - Argument of type 'Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error) | null' is not assignable to parameter of type 'Error | null'.
	storeResourceResult(data, error, loading);

	return null;
};
